// extracted by mini-css-extract-plugin
module.exports = {"boats":"browse-module--boats--1SgyD","moreBoatsCard":"browse-module--moreBoatsCard--2Tdg8"};